import ContactComponent from "../components/Contact";
import PageHeader from "../components/PageHeader";
import StatementPDF from "../components/Statement";

const Statement = () => {
  return (
    <>
      <PageHeader title="Bank Statement" />
      <StatementPDF />
    </>
  );
};

export default Statement;
